"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.extractAirportFilterQuery = extractAirportFilterQuery;
exports.extractAllFiltersQuery = extractAllFiltersQuery;
exports.extractFilterQuery = extractFilterQuery;
exports.extractMultiSelectFilterQuery = extractMultiSelectFilterQuery;
exports.extractNestedMultiSelectFilterQuery = extractNestedMultiSelectFilterQuery;
exports.extractPriceFilterQuery = extractPriceFilterQuery;
var _queryString = _interopRequireDefault(require("query-string"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _constants = require("../constants");
function extractAllFiltersQuery(filtersParams) {
  var queryObj = {};
  (0, _each2.default)(filtersParams, function (filterParams, filterKey) {
    queryObj[_constants.FILTER_PARAMS_MAP[filterKey]] = extractFilterQuery(filterKey, filterParams);
  });
  return _queryString.default.stringify(queryObj, {
    encode: false
  });
}
function extractFilterQuery(filterKey, filterParams) {
  switch (filterKey) {
    case 'airline':
      return extractMultiSelectFilterQuery(filterParams);
    case 'airport':
      return extractAirportFilterQuery(filterParams);
    case 'price':
      return extractPriceFilterQuery(filterParams);
    case 'stop':
      return extractMultiSelectFilterQuery(filterParams);
    case 'maxStop':
      return extractMultiSelectFilterQuery(filterParams);
    case 'departureTime':
      return extractNestedMultiSelectFilterQuery(filterParams);
    case 'arrivalTime':
      return extractNestedMultiSelectFilterQuery(filterParams);
    case 'insuranceOnly':
      return filterParams || undefined;
    case 'hasBaggageOnly':
      return filterParams || undefined;
    case 'isFlex':
      return filterParams || undefined;
    default:
      return '';
  }
}
function extractMultiSelectFilterQuery(filterParams) {
  if (filterParams === void 0) {
    filterParams = [];
  }
  if (!(0, _isArray2.default)(filterParams) || (0, _isEmpty2.default)(filterParams)) {
    return undefined;
  }
  return (0, _join2.default)(filterParams, _constants.FILTER_PARAM_LEG_ITEM_SEPARATOR);
}
function extractNestedMultiSelectFilterQuery(filterParams) {
  if ((0, _isEmpty2.default)(filterParams)) {
    return undefined;
  }
  var queryArray = (0, _map2.default)(filterParams, function (legFilterParams) {
    return extractMultiSelectFilterQuery(legFilterParams) || _constants.FILTER_PARAM_ALL_ITEM;
  });
  if ((0, _every2.default)(queryArray, function (query) {
    return query === _constants.FILTER_PARAM_ALL_ITEM;
  })) {
    return undefined;
  }
  return (0, _join2.default)(queryArray, _constants.FILTER_PARAM_LEG_SEPARATOR);
}
function extractAirportFilterQuery(filterParams) {
  if ((0, _isEmpty2.default)(filterParams)) {
    return undefined;
  }
  var queryArray = (0, _map2.default)(filterParams, function (legFilterParams) {
    var originQuery = extractMultiSelectFilterQuery((0, _get2.default)(legFilterParams, 'origin')) || _constants.FILTER_PARAM_ALL_ITEM;
    var destinationQuery = extractMultiSelectFilterQuery((0, _get2.default)(legFilterParams, 'destination')) || _constants.FILTER_PARAM_ALL_ITEM;
    return (0, _join2.default)([originQuery, destinationQuery], _constants.FILTER_PARAM_AIRPORT_SEPARATOR);
  });
  if ((0, _every2.default)(queryArray, function (query) {
    return query === _constants.FILTER_PARAM_ALL_AIRPORTS;
  })) {
    return undefined;
  }
  return (0, _join2.default)(queryArray, _constants.FILTER_PARAM_LEG_SEPARATOR);
}
function extractPriceFilterQuery(filterParams) {
  if (!filterParams || !(0, _isPlainObject2.default)(filterParams) || !filterParams.from || !filterParams.to) {
    return undefined;
  }
  var min = filterParams.min,
    max = filterParams.max,
    from = filterParams.from,
    to = filterParams.to;
  if (from <= min && to >= max) {
    return undefined;
  }
  return (0, _join2.default)([from, to], _constants.FILTER_PARAM_RANGE_SEPARATOR);
}
var _default = exports.default = extractAllFiltersQuery;